import { BlogDetails } from "../types/blogs-types";

export const BLOGS_URL = "/blogs";

export const MEAT_ECO_FOOTPRINT_BLOG: BlogDetails = {
  id: "MEAT_ECO_FOOTPRINT",
  title: "The Carbon & Water Footprint of India's favourite non-veg dishes",
  description:
    "Explore the environmental footprint of popular Indian non-vegetarian dishes such as Butter Chicken, Mutton Biryani, Beef Curry and more.",
  url: `${BLOGS_URL}/carbon-water-footprint-of-favourite-non-vegetarian-indian-dishes`,
};

export const VEG_ECO_FOOTPRINT_BLOG: BlogDetails = {
  id: "VEG_ECO_FOOTPRINT",
  title: "The Carbon & Water Footprint of India's favourite veg dishes",
  description:
    "Explore the environmental footprint of popular Indian vegetarian dishes such as Palak paneer, Rajma Chawal, Undhiyu and more.",
  url: `${BLOGS_URL}/carbon-water-footprint-of-favourite-vegetarian-indian-dishes`,
};

export const COMPARE_FOOD_ECO_FOOTPRINT_BLOG: BlogDetails = {
  id: "COMPARE_FOOD_ECO_FOOTPRINT",
  title: "Compare the Carbon & Water Footprint of India's favourite dishes",
  description:
    "Compare and contrast the difference in the environmental footprint of popular Indian dishes such as Palak paneer vs butter chicken, and more.",
  url: `${BLOGS_URL}/compare-carbon-water-footprint-of-favourite-indian-dishes`,
};

export const CAR_FUEL_ECO_FOOTPRINT_BLOG: BlogDetails = {
  id: "CAR_FUEL_ECO_FOOTPRINT_BLOG",
  title: "WTW Carbon Footprint of ICE, EV & Hybrid Cars in India",
  description:
    "Explore the Well-to-wheel carbon footprint of petrol, diesel, cng, hybrid and fully electric cars in India.",
  url: `${BLOGS_URL}/well-to-wheel-carbon-footprint-ice-and-electric-and-hybrid-cars-india`,
};
